import { makeStyles } from "@material-ui/core";
import { Colors } from "../../constants";

export default makeStyles((theme) => ({
  colorOption: {
    width: 24,
    height: 24,
    display: "inline-block",
    cursor: "pointer",
    margin: theme.spacing(0, 1),
    backgroundColor: "transparent",
    position: "relative",
    "&::before": {
      // eslint-disable-next-line
      content: '""',
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      backgroundColor: "inherit",
      position: "absolute",
      top: 0,
      left: 0,
    },
  },
  selected: {
    "&::after": {
      // eslint-disable-next-line
      content: '""',
      position: "absolute",
      top: theme.spacing(-0.5),
      left: theme.spacing(-0.5),
      width: 32,
      height: 32,
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: "50%",
    },
  },
  colorBlack: {
    "&::before": {
      backgroundColor: "black",
    },
  },
  colorDarkBlue: {
    "&::before": {
      backgroundColor: Colors.DarkBlue,
    },
  },
  colorBlue: {
    "&::before": {
      backgroundColor: Colors.Blue,
    },
  },
}));
